/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RedirectToDefaultTab/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function RedirectToDefaultTab({
  children,
  viewPath = "/App/Account/Content/RedirectToDefaultTab"
  
}) {
  return null
}